import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import { KonwersjaMapDto, PlikDto, PobieranieDanych, PobieranieDanychAdapter } from '../../mm-core/providers/pobieranie-danych-adapter';

/**
 * Klasa dostarczająca implementację dla pobierania przekonwertowanych danych
 */
@Injectable({
  providedIn: 'root'
})
export class PobieranieDanychProviderService implements PobieranieDanychAdapter {

  /**
   * Konstruktor
   * @param http - klient http
   */
  constructor(private http: HttpClient) {
  }

  /**
   * Funkcja pobierająca pliki eksportu warstw
   * @param dane - konfiguracja konwersji
   */
  pobierzDane(dane: PobieranieDanych): Observable<PlikDto> {
    const url = `${environment.portalKonwersjiApiUrl}/open/konwerter-dane`;
    return this.http
      .post(url, dane, {
        responseType: 'blob',
        observe: 'response'
      })
      .pipe(map((response: any) => (
          {
            data: new Blob([response.body]),
            mimeType: response.headers.get('content-type')
          }
        ))
      );
  }

  /**
   * Funkcja pozwala pobierać mapę do wydruku
   * @param dane - dane do konwersji
   */
  pobierzMape(dane: KonwersjaMapDto): Observable<PlikDto> {
    const url = `${environment.portalKonwersjiApiUrl}/open/mapy`;
    return this.http
      .post(url, dane, {
        responseType: 'blob'
      }).pipe(map((response) => (
          {
            data: new Blob([response])
          }
        ))
      );
  }


}
